import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, STORAGE_KEYS } from '../../constants';

export const maintenanceApi = createApi({
  reducerPath: 'maintenanceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (token) headers.set('authorization', `Bearer ${token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    triggerBackup: builder.mutation<{ success: boolean; data?: any }, void>({
      query: () => ({ url: '/maintenance/backup', method: 'POST' })
    }),
    getBackupStatus: builder.query<{ success: boolean; data: any }, void>({
      query: () => ({ url: '/maintenance/backup/status' })
    })
  })
});

export const { useTriggerBackupMutation, useGetBackupStatusQuery } = maintenanceApi;

